import { Typography } from '@material-ui/core';
import React, { Dispatch, SetStateAction, useState } from 'react';
import VoxelDialog from '../../../../components/voxel/Dialogs/VoxelDialog';
import VoxelDialogActionCancel from '../../../../components/voxel/Dialogs/VoxelDialogActionCancel';
import VoxelDialogActionSubmit from '../../../../components/voxel/Dialogs/VoxelDialogActionSubmit';
import VoxelDialogActions from '../../../../components/voxel/Dialogs/VoxelDialogActions';
import VoxelDialogContent from '../../../../components/voxel/Dialogs/VoxelDialogContent';
import { ContentActionGq } from '../../../../graphql/projects/models/ContentActionGq';
import { ContentKeywordGq } from '../../../../graphql/projects/models/ContentKeywordGq';
import { ContentTaskGq } from '../../../../graphql/projects/models/ContentTaskGq';
import { projectsApiService } from '../../../../graphql/projects/projectsApiService';
import { ContentTaskTableState } from '../Tables/ContentKeywordTable/logic/useContentTaskTableState';
import TaskAction from '../Tables/ContentTaskTable/TaskAction';

export interface ContentKeywordsSplitDialogProps {
  contentTask: ContentTaskGq;
  selectedCount: number;
  selectedKeywordIds: number[];
  tableState: ContentTaskTableState;
  setLocalItems: Dispatch<SetStateAction<ContentKeywordGq[]>>;
  reload: () => Promise<any>;
  openDialog: boolean;
  setOpenDialog: Dispatch<SetStateAction<boolean>>;
}

const ContentKeywordsSplitDialog: React.FC<ContentKeywordsSplitDialogProps> = ({
  contentTask,
  selectedCount,
  selectedKeywordIds,
  tableState,
  setLocalItems,
  reload,
  openDialog,
  setOpenDialog,
}) => {
  const [updating, setUpdating] = useState(false);

  // Mutation
  const splitContentKeywordsMutation =
    projectsApiService.mutations.contentPlan.useSplitToCreateTasks();
  const handleSplitContentKeywords = (
    projectId: number,
    contentTaskId: number,
    contentKeywordIds: number[]
  ) => {
    setUpdating(true);
    setLocalItems((prev) => prev.filter((x) => !contentKeywordIds.includes(x.id)));
    splitContentKeywordsMutation({
      projectId: projectId,
      contentTaskId: contentTaskId,
      contentKeywordIds: contentKeywordIds,
    })
      .then(reload)
      .finally(() => {
        setUpdating(false);
        tableState.handleResetSelection();
        setOpenDialog(false);
      });
  };

  return (
    <VoxelDialog
      maxWClass="max-w-3xl"
      open={openDialog}
      onClose={() => setOpenDialog(false)}
      title="Split to new automatic URLs"
    >
      <VoxelDialogContent>
        <div>
          <Typography variant={'body2'} paragraph>
            Are you sure you want to move{' '}
            <Typography variant={'subtitle2'} component={'span'}>
              {selectedCount} keywords
            </Typography>{' '}
            from this url to new automatic{' '}
            <Typography component={'span'}>
              <TaskAction action={ContentActionGq.CREATE} size={'medium'} table />
            </Typography>{' '}
            urls?
          </Typography>
        </div>
      </VoxelDialogContent>

      <VoxelDialogActions>
        <VoxelDialogActionCancel onClick={() => setOpenDialog(false)} disabled={updating} />
        <VoxelDialogActionSubmit
          title={'New urls'}
          onClick={() => {
            handleSplitContentKeywords(contentTask.projectId, contentTask.id, selectedKeywordIds);
          }}
          disabled={updating}
        />
      </VoxelDialogActions>
    </VoxelDialog>
  );
};

export default ContentKeywordsSplitDialog;
